import { IconProps } from "./IconProps";

const ArrowUpRightIcon: React.FC<IconProps> = ({
  width = 24,
  height = 24,
  color = "#FFFFFF",
}) => {
  return (
    <svg
      fill="none"
      height={height}
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width={width}
    >
      <line x1="7" x2="17" y1="17" y2="7" />
      <polyline points="7 7 17 7 17 17" />
    </svg>
  );
};
export default ArrowUpRightIcon;
